import React, {FC} from 'react';
import styled from 'styled-components';

import {useBaseEditorContext} from '../../editors/baseEditorContext';
import {useRuleEditorContext} from '../../editors/ruleEditor/ruleEditorContext';
import {TriggerWithConditions} from '../ruleTriggerHelpers';
import {EditorStateActions} from './hooks/useEditorState';
import {RuleTriggerAddBlock} from './ruleTriggerAddBlock';
import {RuleTriggerOrBlock} from './ruleTriggerOrBlock';

/*
 * Types.
 */

interface RuleTriggersListProps {
  selectedTriggers: ReadonlyArray<TriggerWithConditions>;
  notDisplayingErrorCards?: ReadonlyArray<string>;
  shouldShowMoreOptions: boolean;

  onAddTrigger: EditorStateActions['onAddTrigger'];
  onUpdateTrigger: EditorStateActions['onUpdateTrigger'];
  onDeleteTrigger: EditorStateActions['onDeleteTrigger'];
  onValidation: EditorStateActions['onValidation'];
}

/*
 * Styles.
 */

const StyledRuleTriggersListWrapper = styled.div`
  display: grid;
  grid-auto-rows: min-content;
`;

/*
 * Component.
 */

export const RuleTriggersList: FC<RuleTriggersListProps> = (props) => {
  const {
    selectedTriggers,
    shouldShowMoreOptions,
    onAddTrigger,
    onUpdateTrigger,
    onDeleteTrigger,
    onValidation,
    notDisplayingErrorCards,
  } = props;
  const {isReadOnly} = useBaseEditorContext();
  const {isLibrary} = useRuleEditorContext();

  const shouldShowAdvanced = isLibrary ? shouldShowMoreOptions : true;
  const canAddTriggers = shouldShowAdvanced && !isReadOnly;
  const onRemoveTrigger = canAddTriggers ? onDeleteTrigger : undefined;

  return (
    <StyledRuleTriggersListWrapper>
      <RuleTriggerOrBlock
        selectedTriggers={selectedTriggers}
        notDisplayingErrorCards={notDisplayingErrorCards}
        onUpdateTrigger={onUpdateTrigger}
        onRemoveTrigger={onRemoveTrigger}
        onValidation={onValidation}
      />
      {canAddTriggers && (
        <RuleTriggerAddBlock selectedTriggers={selectedTriggers} onAddTrigger={onAddTrigger} />
      )}
    </StyledRuleTriggersListWrapper>
  );
};
